// Sugestões super objetivas por faixa de PT (baixo / médio / alto)
// Cada item = { titulo, como, rotina } para aparecer no relatório
const sugestoesICV = {
  DGV: {
    baixo: [
      { titulo: "Objetivo WOOP (5 min/dia)",
        como: "Defina Wish-Outcome-Obstacle-Plan para a semana de vendas.",
        rotina: "Toda 2ª feira, escreva 1 WOOP e revise na 4ª." },
      { titulo: "Pequenas vitórias",
        como: "Divida metas em micro-tarefas de 25min (Pomodoro) e registre vitórias.",
        rotina: "2 pomodoros/dia focados em prospecção." }
    ],
    medio: [
      { titulo: "Ritual de abertura",
        como: "Checklist de 3 passos: planejar ligações, revisar argumentos, aquecer mental.",
        rotina: "10 min antes do expediente." }
    ],
    alto: [
      { titulo: "Mentoria reversa",
        como: "Líder de POD semanal ajudando colegas a estruturar pipeline.",
        rotina: "30 min/semana com 1 colega." }
    ]
  },

  R: { // Receptividade (empatia/escuta/adaptação)
    baixo: [
      { titulo: "Escuta ativa ACR",
        como: "Responda ativamente às boas notícias do cliente (Active-Constructive Responding).",
        rotina: "Em toda call, faça 1 pergunta de aprofundamento + reformule o que ouviu." },
      { titulo: "Mapa de empatia",
        como: "Antes da call, preencha: o que o cliente vê/ouve/pensa/sente.",
        rotina: "5 min de preparação por oportunidade crítica." }
    ],
    medio: [
      { titulo: "Parafrasear e confirmar",
        como: "Feche cada etapa com 'Então, o que importa é X, certo?'",
        rotina: "Em 100% das reuniões de descoberta." }
    ],
    alto: [
      { titulo: "Shadow de discovery",
        como: "Acompanhe 1 vendedor/semana e dê feedback sobre perguntas abertas.",
        rotina: "1 sessão/semana." }
    ]
  },

  A: { // Agressividade (ímpeto competitivo/assertividade)
    baixo: [
      { titulo: "Ensaios de objeção",
        como: "Role-play de 10 objeções frequentes (DESC + pergunta final).",
        rotina: "15 min/dia por 2 semanas." },
      { titulo: "Pedido claro",
        como: "Sempre feche com uma 'próxima ação' e data.",
        rotina: "Em cada call, combine próximo passo no calendário." }
    ],
    medio: [
      { titulo: "Âncora de confiança",
        como: "Relembre 3 cases/ganhos antes da negociação.",
        rotina: "2 min antes de discussões de preço." }
    ],
    alto: [
      { titulo: "CNV + Assertividade",
        como: "Use CNV (observação, sentimento, necessidade, pedido) para reduzir atrito.",
        rotina: "Treinar 1 caso real por semana com o coach." }
    ]
  },

  I: { // Compreensão (empatia/objetividade/intuicao)
    baixo: [
      { titulo: "Perguntas SPIN",
        como: "Planeje 2 perguntas por letra (Situação, Problema, Implicação, Necessidade).",
        rotina: "Antes de toda discovery." }
    ],
    medio: [
      { titulo: "Resumo em 1 frase",
        como: "Após a call, sintetize a dor do cliente em 140 caracteres.",
        rotina: "Sempre após reuniões-chave." }
    ],
    alto: [
      { titulo: "Storytelling com cliente",
        como: "Transforme dores em histórias com herói/obstáculo/plano/sucesso.",
        rotina: "1 história nova por semana." }
    ]
  },

  II: { // Adaptabilidade
    baixo: [
      { titulo: "Plano B/C",
        como: "Para cada call, tenha roteiro alternativo se perder o rumo.",
        rotina: "3 min de preparação por call." }
    ],
    medio: [
      { titulo: "Experimentação 1%",
        como: "Troque 1 micro-comportamento por semana (ex.: ordem de perguntas).",
        rotina: "Revisão na sexta." }
    ],
    alto: [
      { titulo: "A/B de pitch",
        como: "Teste 2 versões do pitch e compare conversão.",
        rotina: "2 semanas por teste." }
    ]
  },

  III: { // Autocontrole
    baixo: [
      { titulo: "Respiração 4-6",
        como: "Inspire 4s, expire 6s para baixar ativação antes da call.",
        rotina: "2 min antes de reuniões importantes." },
      { titulo: "Regulação cognitiva",
        como: "Reenquadrar 'perdi a venda' para 'aprendi X e ajusto Y'.",
        rotina: "Escreva 1 lição após cada perda." }
    ],
    medio: [
      { titulo: "Agenda de energia",
        como: "Bloqueie horários de alta energia para prospecção.",
        rotina: "2 blocos de 50 min/dia." }
    ],
    alto: [
      { titulo: "Protocolo pré-negociação",
        como: "Checklist emocional: objetivo, alternativas, gatilhos, pausas.",
        rotina: "5 min antes de negociar." }
    ]
  },

  IV: { // Tolerância à frustração
    baixo: [
      { titulo: "Pé no chão (3x3)",
        como: "Liste 3 fatos, 3 interpretações possíveis, 3 próximos passos.",
        rotina: "Sempre que levar um 'não'." }
    ],
    medio: [
      { titulo: "Regra dos 10",
        como: "Isso importa em 10 dias/meses/anos? (reavalia impacto).",
        rotina: "Aplicar em setbacks." }
    ],
    alto: [
      { titulo: "Matéria-prima",
        como: "Transforme frustração em material didático pro time.",
        rotina: "1 compartilhamento/semana." }
    ]
  },

  V: { // Combatividade
    baixo: [
      { titulo: "Fechamentos suaves",
        como: "Use perguntas de avanço: 'O que falta para seguirmos?'",
        rotina: "Em toda call de proposta." }
    ],
    medio: [
      { titulo: "Follow-up com valor",
        como: "Cada follow-up leva 1 insight ou case útil.",
        rotina: "Agenda automática + snippet pronto." }
    ],
    alto: [
      { titulo: "Negociação criativa",
        como: "Pense em moedas de troca além de preço (prazo, volume, serviço).",
        rotina: "Checklist antes da negociação." }
    ]
  },

  VI: { // Domínio
    baixo: [
      { titulo: "Pitch de 30s",
        como: "Treine elevator pitch com espelhamento e CTA claro.",
        rotina: "5 reps/dia por 1 semana." }
    ],
    medio: [
      { titulo: "Autoridade social",
        como: "Abra reuniões citando prova social relevante.",
        rotina: "1 credencial forte por call." }
    ],
    alto: [
      { titulo: "Liderança situacional",
        como: "Ajuste diretividade x suporte por perfil de cliente.",
        rotina: "Reflexão pós-call (2 min)." }
    ]
  },

  VII: { // Segurança
    baixo: [
      { titulo: "Diário de autoeficácia",
        como: "Liste 3 conquistas diárias (micro).",
        rotina: "2 min ao final do dia." }
    ],
    medio: [
      { titulo: "Ensaios mentais",
        como: "Visualização do início ao fechamento da call.",
        rotina: "3 min antes da reunião." }
    ],
    alto: [
      { titulo: "Desafios voluntários",
        como: "Assuma deals mais complexos com debrief estruturado.",
        rotina: "1 por mês." }
    ]
  },

  VIII: { // Atividade
    baixo: [
      { titulo: "Regra 2x2",
        como: "2 prospecções novas + 2 follow-ups por dia (mínimo).",
        rotina: "Blocos fixos às 10h e 16h." }
    ],
    medio: [
      { titulo: "Time-boxing",
        como: "Calendário com blocos fechados e buffer de 15min.",
        rotina: "Revisão semanal." }
    ],
    alto: [
      { titulo: "Batching inteligente",
        como: "Agrupe tarefas por contexto (ligações, e-mails, CRM).",
        rotina: "Planejamento diário." }
    ]
  },

  IX: { // Sociabilidade
    baixo: [
      { titulo: "Script de abertura",
        como: "Tenha 3 scripts de quebra-gelo alinhados ao ICP.",
        rotina: "Usar sempre no 1º minuto." }
    ],
    medio: [
      { titulo: "Networking 1-1",
        como: "1 café virtual por semana com cliente/lead/champion.",
        rotina: "Bloqueio 30 min/semana." }
    ],
    alto: [
      { titulo: "Referência ativa",
        como: "Peça indicação quando o NPS ≥ 9.",
        rotina: "Após cada go-live." }
    ]
  }
};

export default sugestoesICV;
